import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { TScenario } from '~/features/scenarios/models'
import { queryKeys } from '~/features/scenarios/utils'
import { EHttpService, EServerPath } from '~/models/api'
import HttpService from '~/services/http'
import { HttpServiceBaseResponse } from '~/services/http/models'
import { store } from '~/store'

const getScenarios = (orgId: string) => {
  return HttpService.get<TScenario[]>(
    {
      path: EServerPath.scenarios,
      query: { orgId },
    },
    EHttpService.scenarios,
  )
}

type TProps = {
  queryOptions?: Partial<UseQueryOptions<HttpServiceBaseResponse<TScenario[]>>>
}

const useGetScenarios = ({ queryOptions = {} } = {} as TProps) => {
  const orgId = store((state) => state.user.organizationId)

  return useQuery({
    queryKey: queryKeys.scenarios(orgId),
    queryFn: () => getScenarios(orgId),
    ...queryOptions,
  })
}

export default useGetScenarios
